<template>
  <div id="quickquote-accident-step-1-component">
    <h1
      data-test="quickquote-personal-accident-headline"
      v-html="contentModel.SharedFields.LabelHeadingStep1"
    />
    <section>
      <!-- Hvem skal forsikres? -->
      <article class="flow-group">
        <fieldset class="control">
          <div class="row">
            <legend class="small-12 columns">
              <h3
                data-test="quickquote-accident-title-insured"
                v-html="contentModel.LabelInsuredPerson"
              />
            </legend>
          </div>
          <div class="row">
            <div class="small-12 medium-6 columns">
              <div class="radio-stacked">
                <Field
                  id="insured-self"
                  :model-value="vueModelData.TemplateModel.Insured"
                  @update:model-value="setInsured"
                  :rules="'required'"
                  type="radio"
                  name="insured"
                  value="self"
                  :label="contentModel.FieldNameInsuredperson"
                  @click="pushInsuredToTagManager('hvem skal forsikres', 'mig selv')"
                />
                <label
                  for="insured-self"
                  v-html="contentModel.LabelInsuredPersonMyself"
                  data-test="quickquote-accident-input-insured-self"
                />
              </div>
            </div>
            <div class="small-12 medium-6 columns">
              <div class="radio-stacked">
                <Field
                  id="insured-child"
                  :model-value="vueModelData.TemplateModel.Insured"
                  @update:model-value="setInsured"
                  type="radio"
                  name="insured"
                  value="child"
                  @click="
                    pushInsuredToTagManager('hvem skal forsikres', 'barn');
                    pushInsuredToTagManager('vis barn forsikres');
                  "
                />
                <label
                  for="insured-child"
                  v-html="contentModel.LabelInsuredPersonChild"
                  data-test="quickquote-accident-input-insured-child"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="small-12 columns">
              <ValidationError name="insured" />
            </div>
          </div>
        </fieldset>
      </article>

      <!-- Information om dig / Information om dit barn -->
      <article v-if="vueModelData.TemplateModel.Insured">
        <div class="control">
          <div class="row">
            <div class="small-12 columns">
              <h3
                data-test="quickquote-accident-label-information-insured"
                v-html="labelInformationAboutInsured"
              />
            </div>
          </div>
          <!-- Adult -->
          <div v-if="vueModelData.TemplateModel.Insured == 'self'">
            <div class="row">
              <div class="small-12 columns">
                <label
                  data-test="quickquote-accident-title-primary-profession"
                  class="text-question"
                  for="quickquote-accident-occupation"
                  v-html="contentModel.FieldNamePrimaryProfession"
                />
              </div>
            </div>
            <div class="row">
              <div class="small-12 columns">
                <Field
                  v-model="vueModelData.TemplateModel.PrimaryProfessionRefId"
                  :rules="'required'"
                  :label="decodeHtml(contentModel.FieldNamePrimaryProfession)"
                  name="occupation"
                  v-slot="{ field }"
                >
                  <VueSelect
                    class="v-select-search-icon"
                    :options="professionListRaw"
                    v-bind="field"
                    :model-value="field.value"
                    @change="(m) => (field.value = m)"
                    :reduce="(option) => option.Id"
                    id="quickquote-accident-occupation"
                    label="Description"
                    data-test="quickquote-accident-select-occupation"
                    :placeholder="contentModel.PlaceholderPrimaryProfession"
                  />
                </Field>
              </div>
            </div>
            <div v-if="contentModel.InfoLinkModalPrimaryProfession.HasInfoLinkModal" class="row">
              <div class="small-12 columns">
                <base-info-link-modal
                  :link-label="contentModel.InfoLinkModalPrimaryProfession.LinkLabel"
                  :title="contentModel.InfoLinkModalPrimaryProfession.Title"
                  :content="contentModel.InfoLinkModalPrimaryProfession.Content"
                  :button-label="contentModel.InfoLinkModalPrimaryProfession.ButtonLabel"
                  :align-right="true"
                />
              </div>
            </div>
            <div class="row">
              <div class="small-12 columns">
                <ValidationError name="occupation" />
              </div>
            </div>
            <div class="row">
              <div class="small-12 columns">
                <label
                  data-test="quickquote-accident-label-age-adult"
                  class="text-question"
                  for="age-adult"
                  v-html="contentModel.LabelAdultAge"
                />
              </div>
            </div>
            <div class="row">
              <div class="small-12 columns">
                <Field
                  id="age-adult"
                  v-model="vueModelData.TemplateModel.AgeAdult"
                  :rules="'required|numeric|min_value:18|max_value:120'"
                  data-test="quickquote-accident-age-adult-input"
                  :label="contentModel.FieldNameAdultAge"
                  name="age-adult"
                  :placeholder="contentModel.PlaceholderAdultAge"
                  type="number"
                  :disabled="vueModelData.IsKnownMember"
                />
              </div>
            </div>
            <div class="row">
              <div class="small-12 columns">
                <ValidationError name="age-adult" />
              </div>
            </div>
            <div class="row">
              <div class="small-12 columns">
                <label
                  data-test="quickquote-accident-label-post-number-adult"
                  class="text-question"
                  for="post-number-adult"
                  v-html="contentModel.FieldNamePostNumber"
                />
              </div>
            </div>
            <div class="row">
              <div class="small-12 columns">
                <Field
                  id="post-number-adult"
                  v-model="vueModelData.TemplateModel.PostNumberAdult"
                  :rules="'required|numeric|min:4|max:4|validate_postalcode'"
                  data-test="quickquote-accident-post-number-adult-input"
                  :label="contentModel.FieldNamePostNumber"
                  name="post-number-adult"
                  :placeholder="contentModel.PlaceholderPostNumber"
                  type="number"
                  :disabled="vueModelData.IsKnownMember"
                />
              </div>
            </div>
            <div class="row">
              <div class="small-12 columns">
                <ValidationError name="post-number-adult" />
              </div>
            </div>
            <fieldset>
              <div class="row">
                <legend class="small-12 columns">
                  <h3-and-tooltip
                    data-test="quickquote-accident-title-selfemployed"
                    :h3="contentModel.LabelSelfEmployed"
                    :tooltip="contentModel.TooltipSelfEmployed"
                  />
                </legend>
              </div>
              <div class="row">
                <div class="small-12 medium-6 columns">
                  <div class="radio-stacked">
                    <Field
                      id="self-employed-true"
                      v-model="vueModelData.TemplateModel.IsSelfemployed"
                      :rules="'required_notnull'"
                      type="radio"
                      name="self-employed"
                      :value="true"
                      :label="decodeHtml(contentModel.FieldNameSelfEmployed)"
                      data-test="quickquote-accident-input-selfemployed-true"
                    />
                    <label for="self-employed-true" v-html="contentModel.SharedContent.LabelYes" />
                  </div>
                </div>
                <div class="small-12 medium-6 columns">
                  <div class="radio-stacked">
                    <Field
                      id="self-employed-false"
                      v-model="vueModelData.TemplateModel.IsSelfemployed"
                      type="radio"
                      name="self-employed"
                      :value="false"
                      data-test="quickquote-accident-input-selfemployed-false"
                    />
                    <label for="self-employed-false" v-html="contentModel.SharedContent.LabelNo" />
                  </div>
                </div>
              </div>
            </fieldset>
            <div class="row">
              <div class="small-12 columns">
                <ValidationError name="self-employed" />
              </div>
            </div>
          </div>
          <!-- Child -->
          <div v-if="vueModelData.TemplateModel.Insured == 'child'">
            <div class="row">
              <div class="small-12 columns">
                <label
                  data-test="quickquote-accident-label-age-child"
                  class="text-question"
                  v-html="contentModel.LabelChildAge"
                />
              </div>
            </div>
            <div class="row">
              <div class="small-12 columns">
                <Field
                  id="age-child"
                  :model-value="vueModelData.TemplateModel.AgeChild"
                  @update:model-value="setAgeChild"
                  :rules="'required|numeric|min_value:0|max_value:17'"
                  data-test="quickquote-accident-age-child-input"
                  :label="contentModel.FieldNameChildAge"
                  name="age-child"
                  :placeholder="contentModel.PlaceholderChildAge"
                  type="number"
                />
              </div>
            </div>
            <div class="row">
              <div class="small-12 columns">
                <ValidationError name="age-child" />
              </div>
            </div>

            <div class="row">
              <div class="small-12 columns">
                <label
                  data-test="quickquote-accident-label-firstname-child"
                  class="text-question"
                  v-html="contentModel.LabelFirstName"
                />
              </div>
            </div>
            <div class="row">
              <div class="small-12 columns">
                <Field
                  id="firstname-child"
                  v-model="vueModelData.TemplateModel.Firstname"
                  :rules="'required'"
                  data-test="quickquote-accident-firstname-child-input"
                  name="firstname-child"
                  :placeholder="contentModel.PlaceholderChildName"
                  :label="contentModel.LabelFirstName"
                  type="text"
                />
              </div>
              <div class="row">
                <div class="small-12 columns">
                  <ValidationError name="firstname-child" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="small-12 columns">
                <label
                  data-test="quickquote-accident-label-post-number-child"
                  class="text-question"
                  v-html="contentModel.FieldNamePostNumber"
                />
              </div>
            </div>
            <div class="row">
              <div class="small-12 columns">
                <Field
                  id="post-number-child"
                  v-model="vueModelData.TemplateModel.PostNumberChild"
                  :rules="'required|numeric|min:4|max:4|validate_postalcode'"
                  data-test="quickquote-accident-post-number-child-input"
                  name="post-number-child"
                  :placeholder="contentModel.PlaceholderPostNumber"
                  :label="contentModel.FieldNamePostNumber"
                  type="number"
                />
              </div>
            </div>
            <div class="row">
              <div class="small-12 columns">
                <ValidationError name="post-number-child" />
              </div>
            </div>
          </div>
        </div>
      </article>

      <!-- Shared -->
      <article v-if="vueModelData.TemplateModel.Insured && showHasReportedInsuranceClaims">
        <fieldset class="control">
          <div class="row">
            <legend class="small-12 columns">
              <h3
                data-test="quickquote-accident-has-reported-insurance-claims"
                v-html="labelHasReportedInsuranceClaims"
              />
            </legend>
          </div>
          <div class="row">
            <div class="small-12 medium-6 columns">
              <div class="radio-stacked">
                <Field
                  id="has-reported-insurance-claims-true"
                  v-model="quickQuoteStepModel.hasReportedInsuranceClaims"
                  :rules="'required_notnull'"
                  type="radio"
                  name="has-reported-insurance-claims"
                  :value="true"
                  :label="contentModel.FieldNameHasReportedInsuranceClaims"
                  data-test="quickquote-accident-input-has-reported-insurance-claims-true"
                  @change="setQuestionnaireToZeroAnswer"
                />
                <label
                  for="has-reported-insurance-claims-true"
                  v-html="contentModel.SharedContent.LabelYes"
                />
              </div>
            </div>
            <div class="small-12 medium-6 columns">
              <div class="radio-stacked">
                <Field
                  id="has-reported-insurance-claims-false"
                  v-model="quickQuoteStepModel.hasReportedInsuranceClaims"
                  type="radio"
                  name="has-reported-insurance-claims"
                  :value="false"
                  data-test="quickquote-accident-input-has-reported-insurance-claims-false"
                  @change="setQuestionnaireToZeroAnswer"
                />
                <label
                  for="has-reported-insurance-claims-false"
                  v-html="contentModel.SharedContent.LabelNo"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="small-12 columns">
              <ValidationError name="has-reported-insurance-claims" />
            </div>
          </div>
        </fieldset>
      </article>

      <!-- Questionnaire -->
      <div v-if="showQuestionnaire" class="control">
        <hr />
        <questionnaire
          :options="policyQuestionsWithoutZeroAnswer"
          :always-show="true"
          :heading-three="true"
          @questionnaire-updated="getQuestionnaireAnswersFromId"
        />
      </div>
    </section>
  </div>
</template>

<script>
import QuickQuoteMixin from './QuickQuoteMixin.vue';
import H3AndTooltip from '@/components/UI/H3AndTooltip.vue';
import Utility from '@/common/UtilityFunctions.js';
import BaseInfoLinkModal from '@/components/Forms/BaseInfoLinkModal/BaseInfoLinkModal.vue';
import ValidationError from '@/components/UI/ValidationError.vue';
import { sortBy, forEach, cloneDeep } from 'lodash';
import { FormContextKey } from 'vee-validate';
import { inject } from 'vue';

export default {
  name: 'AccidentQuickQuote1000081',
  components: {
    H3AndTooltip,
    BaseInfoLinkModal,
    ValidationError
  },
  mixins: [QuickQuoteMixin],
  emits: ['update-personal-information', 'disable-next-button'],
  setup() {
    return { form: inject(FormContextKey, undefined) };
  },
  mounted() {
    this.initialTemplateModel = cloneDeep(this.vueModelData.TemplateModel);
    
    const self = this;
    forEach(this.stepModel, (val, key) => {
      self.quickQuoteStepModel[key] = val;
    });
  },
  props: {
    contentModel: {
      type: Object,
      default() {
        return {};
      }
    },
    vueModel: {
      type: Object,
      default() {
        return {};
      }
    },
    stepModel: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      quickQuoteStepModel: {
        type: Object,
        default() {
          return {
            hasReportedInsuranceClaims: null
          };
        }
      },
      vueModelData: this.vueModel,
      isBlocked: false,
      initialTemplateModel: {},
      professionListRaw: this.contentModel.ProfessionGroupList,
    };
  },
  computed: {
    personalInformationForTagManager() {
      if(!this.vueModelData.TemplateModel) return null;

      return {
        event: 'track-event',
        eventCategory: this.getDanishProductTypeName + ' prisberegner',
        eventAction: '01 oplysninger submit ok',
        eventLabel: 'oplysninger submit ok',
        eventValue: '0',
        eventNoninteraction: true,
        data: {
          hvemforsikres:
            this.vueModelData.TemplateModel.Insured === 'child' ? 'barn i husstanden' : 'mig selv',
          selvstændig: this.vueModelData.TemplateModel.IsSelfemployed ? 'ja' : 'nej',
          beskæftigelse:
            this.vueModelData.TemplateModel.PrimaryProfessionRefId !== null
              ? this.professionListRaw.find(
                  (obj) => obj.Id === this.vueModelData.TemplateModel.PrimaryProfessionRefId
                ).Description
              : '',
          harbibeskæftigelse: this.vueModelData.TemplateModel.HasSecondaryProfession ? 'ja' : 'nej',
          bibeskæftigelse:
            this.vueModelData.TemplateModel.SecondaryProfessionRefId !== null
              ? this.professionListRaw.find(
                  (obj) => obj.Id === this.vueModelData.TemplateModel.SecondaryProfessionRefId
                ).Description
              : '',
          bibeskæftigelsetimer: this.vueModelData.TemplateModel.WorkingHourPerWeek
        }
      };
    },
    policyQuestionsWithoutZeroAnswer() {
      if (
        this.vueModelData.TemplateModel?.PolicyQuestionnaire === undefined ||
        this.vueModelData.TemplateModel?.PolicyQuestionnaire === null
      ) {
        return [];
      }
      let questionnaires = this.vueModelData.TemplateModel.PolicyQuestionnaire.Questionnaires;
      if (
        questionnaires.length > 0 &&
        questionnaires[0].AnswersList.length > 0 &&
        questionnaires[0].AnswersList[0].Value === '0'
      ) {
        questionnaires[0].AnswersList.shift();
      }
      return sortBy(questionnaires, 'SortOrder');
    },
    policyQuestionDamagesLastThreeYears() {
      if (
        this.vueModelData.TemplateModel?.PolicyQuestionnaire === undefined ||
        this.vueModelData.TemplateModel?.PolicyQuestionnaire === null
      ) {
        return null;
      }
      return this.vueModelData.TemplateModel.PolicyQuestionnaire.Questionnaires.filter(
        (el) => el.LineId == 1002244
      )[0];
    },
    showHasReportedInsuranceClaims() {
      return this.vueModelData.TemplateModel.AgeChild != 0 ? true : false;
    },
    showQuestionnaire() {
      return this.quickQuoteStepModel.hasReportedInsuranceClaims &&
        this.showHasReportedInsuranceClaims
        ? true
        : false;
    },

    labelInformationAboutInsured() {
      if (this.vueModelData.TemplateModel.Insured === 'child') {
        return this.contentModel.LabelInformationAboutYourChild;
      }
      return this.contentModel.LabelInformationAboutYou;
    },
    labelHasReportedInsuranceClaims() {
      if (this.vueModelData.TemplateModel.Insured === 'child') {
        return this.contentModel.LabelHasReportedInsuranceClaimsChild;
      }
      return this.contentModel.LabelHasReportedInsuranceClaimsAdult;
    }
  },
  watch: {
    'policyQuestionDamagesLastThreeYears.ChosenAnswer': function (val) {
      if (val == 1001441) {
        this.$emit('disable-next-button', true);
        this.showErrorModal();
      } else {
        this.updateBlockStatus();
      }
    },
    'vueModelData.TemplateModel.PrimaryProfessionRefId': function (val) {
      if (this.policyQuestions[0].ChosenAnswer === null) {
        this.setQuestionnaireToZeroAnswer();
      }

      if (val === null) {
        return;
      }

      this.updateQuickQuoteAsset((response) => {
        if (response.Asset.HighRiskOccupation) {
          // this.$parent.$emit('showStdErrorModal', true);
          this.$parent.$parent.$parent.showQuickQuoteModalErrorValidation = false;
          this.$parent.$parent.$parent.showQuickQuoteModal = true;
          this.$emit('disable-next-button', true);
        } else {
          this.updateBlockStatus();
        }
      });
    },
    'quickQuoteStepModel.hasReportedInsuranceClaims': function (val) {
      this.stepModel.hasReportedInsuranceClaims = val;
      if (val) {
        if (!this.vueModelData.TemplateModel.Asset && this.policyQuestions[0].ChosenAnswer !== null) {
          this.setQuestionnaireToNullAnswer();
        }
      } else {
        this.setQuestionnaireToZeroAnswer();
      }
    },
    personalInformationForTagManager() {
      this.$emit('update-personal-information', this.personalInformationForTagManager);
    },
    'vueModelData.TemplateModel.Insured': function (val, oldVal) {
      if (oldVal !== null) {
        this.vueModelData.TemplateModel.PrimaryProfessionRefId = null;
        this.vueModelData.TemplateModel.IsSelfemployed = null;
        this.vueModelData.TemplateModel.AgeChild = null;
        this.vueModelData.TemplateModel.Firstname = null;
        this.vueModelData.TemplateModel.PostNumberChild = null;
        this.quickQuoteStepModel.hasReportedInsuranceClaims = null;
        this.form.resetField('has-reported-insurance-claims');

        if (!this.vueModel.IsKnownMember) {
          this.vueModelData.TemplateModel.AgeAdult = null;
          this.vueModelData.TemplateModel.PostNumberAdult = null;
        }   
      }
    }
  },
  methods: {
    decodeHtml: Utility.decodeHtml,
    setAgeChild(val) {
      this.vueModelData.TemplateModel.AgeChild = val;
      if (val == 0) {
        this.setQuestionnaireToZeroAnswer();
      } else {
        this.setQuestionnaireToNullAnswer();
      }
    },
    setInsured(val) {
      this.vueModelData.TemplateModel = cloneDeep(this.initialTemplateModel);
      this.vueModelData.TemplateModel.Insured = val;
      this.quickQuoteStepModel.hasReportedInsuranceClaims = null;
      this.form.setErrors({});
    },
    setQuestionnaireToZeroAnswer() {
      this.vueModelData.TemplateModel.PolicyQuestionnaire.Questionnaires[0].ChosenAnswer = 1001437;
    },
    setQuestionnaireToNullAnswer() {
      this.vueModelData.TemplateModel.PolicyQuestionnaire.Questionnaires[0].ChosenAnswer = null;
    },
    updateBlockStatus() {
      if (!this.isBlocked) {
        this.$emit('disable-next-button', false);
      }
    },
    getQuestionnaireAnswersFromId(param) {
      if (param.answer && param.answer.Block) {
        this.$emit('disable-next-button', true);
        this.showErrorModal();
      }
      this.isBlocked = param.blockStatus;
      this.updateBlockStatus();
    },
    // Tag Manager tracking
    pushInsuredToTagManager(action, label = '') {
      Utility.pushToTagManager({
        event: 'track-event',
        eventCategory: this.getDanishProductTypeName + ' prisberegner',
        eventAction: '01 oplysninger - ' + action,
        eventLabel: label,
        eventValue: '0',
        eventNoninteraction: true
      });
    }
  }
};
// TODO: Pop-up ved “high risk occupation” - der kommer felt på asset så man bør updateQuickQuoteAsset() som på hus?
// TODO: Ved 17 år udløses samme pop-up som ved at klikke på tooltip - toogle VV rules
</script>
